import { DisplayPriceGettingParams, DisplayPriceGettingSpecificPriceParams } from '../../../../../baseComponents/Displays/DisplayPrice'
import { RowData } from '../../../../../baseComponents/TwinTable/types'
import { SpecificPriceRules } from '../../../../../utils/reducers/products/specificPriceRules'

interface CustomRenderSpecificPriceProps {
    allRowData: RowData
    specificPriceRules: SpecificPriceRules | null
}

export const CustomRenderSpecificPrice: React.FC<CustomRenderSpecificPriceProps> = ({allRowData, specificPriceRules }) => {
    return (
        <DisplayPriceGettingSpecificPriceParams value={parseFloat(allRowData?.['Product.SpecificPricesProduct.calculated_price'])} CurrencyId={specificPriceRules?.dictionary[allRowData?.['Product.SpecificPricesProduct.SpecificPriceRuleId']]?.CurrencyId || ''} with_vat={false} specificPriceRules={specificPriceRules} SpecificPriceRuleId={specificPriceRules?.defaultSpecificPriceRuleId || 1} />
    )
}


interface CustomRenderPriceWithMarginProps {
    allRowData: RowData
    CurrencyId: string
}

export const CustomRenderPriceWithMargin: React.FC<CustomRenderPriceWithMarginProps> = ({ allRowData, CurrencyId }) => {
    const price = allRowData.unitPriceWithComplementsMargin
    return (
        <DisplayPriceGettingParams value={price} CurrencyId={CurrencyId || ''} with_vat={false} />
    )
}